module.exports = __webpack_public_path__ + "static/media/horizontalRectangle_turquoise.700d3f6a.svg";